import {
  APP_DOWNLOAD_SNOOZE_COOKIE,
  APP_DOWNLOAD_SNOOZE_DURATION_MS,
} from "@benefit-systems/shared/features/mybenefit-app-download";
import { getMobilePlatform } from "@benefit-systems/shared/utils/platform";
import { isNativeApp } from "@benefit-systems/webview/utils";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { ModalActionTypes } from "web/hooks/useModal/useModalTypes";

import { getLoginCount } from "web/utils/loginCount";
import getCookie from "web/utils/system/cookie/getCookie";
import setCookie from "web/utils/system/cookie/setCookie";

import { useAppContext } from "web/context/app";

import NativeAppDownloadModal from "./NativeAppDownloadModal";
import classes from "./container.scss";
import NavigationPanel from "./navigationPanel";

const hiddenPanelMobilePathNames = [
  "/checkout/",
  "/checkout_failed/",
  "/company-events",
  "/checkout-external/prepaid-card",
];

const NavigationPanelContainer = () => {
  const { pathname } = useLocation();
  const { isMobile, modal } = useAppContext();
  const { dispatch } = modal;

  const shouldShowNavigationPanel = useMemo(
    () =>
      isMobile &&
      !hiddenPanelMobilePathNames.some((path) => pathname.includes(path)),
    [isMobile, pathname]
  );

  useEffect(() => {
    if (getLoginCount() < 2) return;

    const shouldSkipModal = getCookie(APP_DOWNLOAD_SNOOZE_COOKIE);
    const shouldShowModal = !isNativeApp() && !shouldSkipModal;
    const platform = getMobilePlatform();

    const handleClick = () => {
      setCookie(
        APP_DOWNLOAD_SNOOZE_COOKIE,
        "1",
        APP_DOWNLOAD_SNOOZE_DURATION_MS
      );
      dispatch({ type: ModalActionTypes.RESET });
    };

    if (shouldShowModal && platform) {
      dispatch({
        type: ModalActionTypes.ADD_MODAL,
        modal: (
          <NativeAppDownloadModal
            platform={platform}
            onStoreClick={handleClick}
            onRemindLater={handleClick}
          />
        ),
        classes: { root: classes.modal },
        persistent: true,
        fullscreen: true,
      });
    }
  }, [isMobile, dispatch]);

  return shouldShowNavigationPanel ? <NavigationPanel /> : null;
};

export default NavigationPanelContainer;
